import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.number.constructor.js";
export default {
  layout: 'battle',
  data: function data() {
    return {
      ogpTitle: this.$t('common.meta.title'),
      ogpDescription: this.$t('common.meta.description'),
      ogpImageUrl: "".concat(this.$env.siteUrl, "ogp.png"),
      ogpUrl: this.$env.siteUrl + this.$route.fullPath.substring(1)
    };
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    currentLandCupInfo: function currentLandCupInfo() {
      return useLandCupStore().currentLandCupInfo;
    },
    SoundVolume: function SoundVolume() {
      return useSoundStatus().SoundVolume;
    },
    url: function url() {
      // New Quest Battle Url 用
      if (this.$route.query.qbhash) {
        var battleIds = this.$route.query.qbhash.split('_');
        var currentQuestBattleId = Number(battleIds.splice(0, 1));

        // return (`http://127.0.0.1:8000/${currentQuestBattleId}.json`)
        var qdomain = this.$env.questJsonUrl;
        return qdomain + this.me.uid + '/' + currentQuestBattleId + '.json';
      }

      // Frontier Mission
      if (this.$route.query.missionId) {
        var _battleId = this.$route.params.id;
        var missionId = this.$route.query.missionId;
        var _domain = this.$env.missionJsonUrl;
        return _domain + missionId + '/' + _battleId + '.json';
      }

      // simulator
      if (this.$route.query.simulator) {
        var _battleId2 = this.$route.params.id;
        var _domain2 = 'https://rsc-stg.bfh-alim.com/battle/simulate/';
        return _domain2 + _battleId2 + '.json';
      }

      // fg
      if (this.$route.query.fgType) {
        var _battleId3 = this.$route.params.id;
        var _domain3 = this.$env.fgJsonUrl + this.$route.query.fgType + '/';
        return _domain3 + _battleId3 + '.json';
      }

      // raid
      if (this.$route.query.raidId) {
        var _battleId4 = this.$route.params.id;
        var _domain4 = this.$env.raidJsonUrl + this.$route.query.raidId + '/';
        return _domain4 + _battleId4 + '.json';
      }

      //preview //http://localhost:3000/ja/battle/33901451?preview=test&type=true
      if (this.$route.query.preview) {
        var _battleId5 = this.$route.params.id;
        var _domain5 = this.$env.cdnUrl + '/battle/preview/';
        return _domain5 + _battleId5 + '.json';
      }

      // Arena Battle
      var battleId = this.$route.params.id;
      var group = Math.floor(battleId / 100);
      group = group < 1 ? 0 : group;
      var domain = this.$env.battleJsonUrl;
      return domain + group + '/' + battleId + '.json';
    },
    redirect: function redirect() {
      // タイトルマッチ
      if (this.$route.query.cupId != null) {
        var cupId = this.$route.query.cupId;
        var url = '/cups/' + cupId + '/users';
        if (this.$route.query.uId) url += '/' + this.$route.query.uId;
        return this.localePath(url);
        // 新タイトルマッチ
      } else if (this.$route.query.titleMatchId != null) {
        var titleMatchId = this.$route.query.titleMatchId;
        var _url = '/titlematch/' + titleMatchId + '/users';
        if (this.$route.query.uId) _url += '/' + this.$route.query.uId;
        if (this.$route.query.viewresult) {
          _url += '?viewresult=true';
          if (this.$route.query.type) _url += '&type=' + this.$route.query.type + '&index=' + this.$route.query.index;
        } else if (this.$route.query.type) {
          _url += '?type=' + this.$route.query.type + '&index=' + this.$route.query.index;
        }
        return this.localePath(_url);
        // 新ランクマッチ
      } else if (this.$route.query.rankMatchId != null) {
        var rankMatchId = this.$route.query.rankMatchId;
        var _url2 = '/rankmatch/' + rankMatchId;
        if (this.$route.query.viewresult) {
          _url2 += '?viewresult=true';
        }
        return this.localePath(_url2);
        // プレイヤーマッチ
      } else if (this.$route.query.arenaId != null) {
        var arenaId = this.$route.query.arenaId;
        return this.localePath('/duel/arena/' + arenaId);
        // クエスト
      } else if (this.$route.query.qbhash) {
        // New Quest Battle Url 用
        var battleIds = this.$route.query.qbhash.split('_');
        var currentQuestBattleId = Number(battleIds.splice(0, 1));

        // GO TO NEXT
        if (battleIds.length == 0) {
          return this.localePath({
            path: "/battle/quest/next",
            query: {
              time: Math.round(new Date().getTime() / 1000),
              type: this.$route.query.type
            }
          });
        }
        // Back TO BATTLE
        else {
          var basePath = '/battle?qbhash=';
          var max = battleIds.length;
          for (var i = 0; i < max; i++) {
            basePath += battleIds[i];
            basePath += i < max - 1 ? '_' : '';
          }
          basePath += '&type=' + this.$route.query.type;
          return this.localePath(basePath);
        }
        // return this.localePath( { path: `/battle/quest/next`, query: { time: Math.round((new Date()).getTime() / 1000) } })
        // return this.localePath('battle-quest-next')
        // チュートリアル
      } else if (this.$route.query.tutorialPath) {
        return this.localePath(this.$route.query.tutorialPath);
        // フロンティアミッション
      } else if (this.$route.query.missionId) {
        return this.localePath({
          path: "/quests/cooperation",
          query: {
            missionId: this.$route.query.missionId,
            page: this.$route.query.page,
            category: this.$route.query.category,
            cooperationType: this.$route.query.cooperationType
          }
        });
        //- WCC予選
      } else if (this.$route.query.wccClassId != null) {
        var wccClassId = this.$route.query.wccClassId;
        return this.localePath("/land/arena/".concat(wccClassId, "/detail"));
        //- WCC本選
      } else if (this.$route.query.matchGroupId != null) {
        var matchGroupId = this.$route.query.matchGroupId;
        return this.localePath({
          path: "/land/arena/international/".concat(matchGroupId),
          query: {
            fcId: this.$route.query.fcId
          }
        });
        //- DSC
      } else if (this.$route.query.dscId != null) {
        var dscId = this.$route.query.dscId;
        var matchId = this.$route.query.mId;
        return this.localePath({
          path: "/land/guild/arena/".concat(dscId, "/battle"),
          query: {
            mId: matchId
          }
        });
        //- simulator
      } else if (this.$route.query.simulator) {
        return this.localePath('simulator');
        //- fg
      } else if (this.$route.query.fgType) {
        if (this.$route.query.history) {
          return this.localePath({
            path: "/quests/event/frontiergate/history",
            query: {
              fgType: this.$route.query.fgType
            }
          });
        } else if (this.$route.query.ranking) {
          return this.localePath({
            path: "/quests/event/frontiergate/ranking",
            query: {
              fgType: this.$route.query.fgType,
              uid: this.$route.query.uid
            }
          });
        } else {
          return this.localePath({
            path: "/battle/quest/fgnext",
            query: {
              fgType: this.$route.query.fgType
            }
          });
        }
        //- raid
      } else if (this.$route.query.raidId) {
        return this.localePath('quests-event-raid-index-challenge');
        //- WCC結果
      } else if (this.$route.query.wccPastResult) {
        return this.localePath('pastresult-wcc');
        //- 総力戦
      } else if (this.$route.query.warMatchId) {
        return this.localePath({
          path: "/land/alloutwar/".concat(this.$route.query.warMatchId, "/battlepanel"),
          query: {
            tabIndex: this.$route.query.tabIndex,
            panelId: this.$route.query.panelId,
            viewedBattle: true
          }
        });
      } else {
        return this.localePath('/');
      }
    },
    reverse: function reverse() {
      if (this.$route.query.reverse != null) {
        var isReverse = this.$route.query.reverse === 'true';
        return isReverse ? 1 : 0;
      }
      return 0;
    },
    soundOn: {
      get: function get() {
        return useSoundStatus().IsSoundOn ? 1 : 0;
      },
      set: function set(val) {}
    },
    autoPlay: function autoPlay() {
      if (this.$route.query.autoplay != null) {
        return Number(this.$route.query.autoplay);
      }
      return 0;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var uid, type, battleId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!_this.$route.query.fgType) {
              _context.next = 7;
              break;
            }
            uid = _this.$route.query.uid ? _this.$route.query.uid : 0;
            type = _this.$route.query.fgType;
            battleId = _this.$route.params.id;
            _context.next = 7;
            return _this.$questsService.checkBattleId(uid, type, battleId);
          case 7:
            _context.next = 14;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
            _this.$toast.error('Error.');
            return _context.abrupt("return", _this.$router.push("".concat(_this.$i18n.locale == 'ja' ? '/ja' : '', "/")));
          case 14:
            _context.next = 16;
            return _this.$soundService.stopAll();
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$soundService.stopAll();
    this.$soundService.playMainBgm();
  },
  methods: {
    playBgm: function playBgm() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              useSoundStatus().initSoundOn();
              if (!(_this2.$route.query.qbhash || _this2.$route.query.tutorialPath)) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return _this2.$soundService.playQuestBgm();
            case 4:
              _context2.next = 28;
              break;
            case 6:
              if (!(_this2.$route.query.matchGroupId != null)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 9;
              return _this2.$soundService.playWccBgm(_this2.currentLandCupInfo.bgmId);
            case 9:
              _context2.next = 28;
              break;
            case 11:
              if (!(_this2.$route.query.dscId != null)) {
                _context2.next = 16;
                break;
              }
              _context2.next = 14;
              return _this2.$soundService.playDscBgm();
            case 14:
              _context2.next = 28;
              break;
            case 16:
              if (!(_this2.$route.query.raidId != null)) {
                _context2.next = 21;
                break;
              }
              _context2.next = 19;
              return _this2.$soundService.playRaidBgm();
            case 19:
              _context2.next = 28;
              break;
            case 21:
              if (!(_this2.$route.query.fgType != null)) {
                _context2.next = 26;
                break;
              }
              _context2.next = 24;
              return _this2.$soundService.playFgBgm();
            case 24:
              _context2.next = 28;
              break;
            case 26:
              _context2.next = 28;
              return _this2.$soundService.playBattleBgm();
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  head: function head() {
    // script: [
    //   {
    //     // src: '/scripts/bf_j13.js'
    //   },
    // ],
    return {
      meta: [{
        'http-equi': 'Content-Type',
        content: 'text/html;'
      }, {
        'http-equiv': 'Content-Script-Type',
        content: 'text/javascript'
      }, {
        'http-equiv': 'Content-Style-Type',
        content: 'text/css'
      }, {
        'http-equiv': 'Pragma',
        content: 'no-cache'
      }, {
        'http-equiv': 'Cache-Control',
        content: 'no-cache'
      },
      //ogpタイトルを設定する
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.ogpTitle
      }, {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: this.ogpTitle
      },
      //ogp説明文を設定する
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.ogpDescription
      }, {
        hid: 'description',
        name: 'description',
        content: this.ogpDescription
      }, {
        hid: 'itemprop-description',
        itemprop: 'description',
        content: this.ogpDescription
      }, {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: this.ogpDescription
      },
      //ogp urlを設定
      {
        hid: 'og:url',
        property: 'og:url',
        content: this.ogpUrl
      },
      //ogp画像を設定する
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.ogpImageUrl
      }, {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: this.ogpImageUrl
      },
      //twitterカード属性を設定する
      {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: 'summary_large_image'
      }, {
        charset: 'utf-8'
      }, {
        name: 'viewport',
        id: 'viewport',
        content: 'width = device-width,initial-scale = 1, minimum-scale = 1, maximum-scale = 1'
      }, {
        name: 'apple-mobile-web-app-capable',
        content: 'yes'
      }, {
        name: 'apple-mobile-web-app-status-bar-style',
        content: 'black'
      }]
    };
  }
};